// Polyfills window.electronAPI's two Cause List cache methods for the browser
// (PWA) build, so CauseList.js's existing window.electronAPI?.save/loadCauseListCache
// calls work unmodified outside Electron. Backed by localStorage instead of the
// Electron main process's userData JSON file (see public/electron.js). Only runs
// when window.electronAPI is not already defined by public/preload.js, so it is
// a strict no-op inside the real Electron app.

const CACHE_KEY = "rglawz.causeListCache.v1";

if (typeof window !== "undefined" && !window.electronAPI) {
  window.electronAPI = {
    saveCauseListCache: async (payload) => {
      try {
        window.localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
        return { success: true };
      } catch (err) {
        console.error("Failed to save cause list cache:", err);
        return { success: false, error: err.message };
      }
    },
    loadCauseListCache: async () => {
      try {
        const raw = window.localStorage.getItem(CACHE_KEY);
        if (!raw) return { success: false, error: "no-cache" };
        return { success: true, data: JSON.parse(raw) };
      } catch (err) {
        return { success: false, error: err.message };
      }
    },
  };
}
